module.exports = {
      id: "alert-yellow-usage",
      viewBox: "0 0 30 27",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#alert-yellow",
      toString: function () {
        return this.url;
      }
    }